// extracted by mini-css-extract-plugin
module.exports = {"pending":"State_pending__3C8cE","approved":"State_approved__1Axex","denied":"State_denied__2NDNm"};